import ruLogo from '../../../../public/new-design/images/logos/ru/header-logo.svg';
import enLogo from '../../../../public/new-design/images/logos/en/header-logo.svg';
import deLogo from '../../../../public/new-design/images/logos/de/header-logo.svg';
import hiLogo from '../../../../public/new-design/images/logos/hi/header-logo.svg';
import trLogo from '../../../../public/new-design/images/logos/tr/header-logo.svg';
import { TLocale } from '@shared/model/types/currentLocale.type';

export const getCurrentLogoByLocale = (currentLocale: TLocale) => {
    switch (currentLocale) {
        case 'ru':
            return ruLogo;
        case 'en':
            return enLogo;
        case 'de':
            return deLogo;
        case 'hi':
            return hiLogo;
        case 'tr':
            return trLogo;
        default: return ruLogo;
    }
}